/**
 * API Response Transformers
 * Converts Pascal case API responses to camel case application types
 */

import { MESSAGE_ROLE, Messages } from '../../Message/types/messages';
import { ApiMessage, ApiMessagesResponse } from '../types/apiTypes';

/**
 * Transform API message to application message format
 * Converts Pascal case to camel case and normalizes types
 */
export const transformApiMessage = (msg: ApiMessage) => ({
  role: msg.Role.toLowerCase() as MESSAGE_ROLE,
  message: msg.Message,
  messageId: msg.MessageId,
  actionStates: {
    liked: msg.ActionStates?.Liked !== undefined 
      ? (msg.ActionStates.Liked === 'true' ? true : msg.ActionStates.Liked === 'false' ? false : null)
      : null,
  },
  messageReferences: msg.MessageReferences?.map((ref) => ({
    title: ref.Title,
    href: ref.Url, // Map Url to href for compatibility
    url: ref.Url,
    itemType: ref.ItemType,
  })) || undefined,
});

/**
 * Transform API messages response to application Messages type
 * Converts Pascal case to camel case for the entire response
 */
export const transformApiMessagesResponse = (data: ApiMessagesResponse): Messages => ({
  sessionId: data.SessionId,
  messages: data.Messages.map(transformApiMessage),
});

